import { render } from "./scrollbar.vue?vue&type=template&id=8c93f5e2"
import script from "./scrollbar.vue?vue&type=script&lang=js"
export * from "./scrollbar.vue?vue&type=script&lang=js"

import "./scrollbar.vue?vue&type=style&index=0&id=8c93f5e2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__